export default __webpack_public_path__ + "6d64438c1d5babbaceee364c16772849.png";